import { h, Component } from 'preact'
import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control/index'
import Icon from '../assets'

export type Group = {
  id: number,
  title: string
}

type Props = {
  groups: Group[],
  onGroupSelected: (groupId: number) => void,
  disabled?: boolean
}

type State = {
  selectedGroup?: Group
}

class GroupSelector extends Component<Props, State> {
  groups: Group[] = []

  constructor (props: Props) {
    super(props)

    this.getDropdownItems = this.getDropdownItems.bind(this)
    this.selectGroup = this.selectGroup.bind(this)
  }

  getDropdownItems () {
    const { groups } = this.props
    return groups.map(({ id, title }) => ({
      title: title,
      onClick: () => this.selectGroup(id, title),
      value: id.toString()
    }))
  }

  selectGroup (id: number, title: string) {
    this.setState({ selectedGroup: { id, title } })
    this.props.onGroupSelected(id)
  }

  render ({ groups, onGroupSelected, disabled }: Props, { selectedGroup }: State) {
    return (
      <DropdownControl
        align='adjust'
        triggerClass='group-select__trigger'
        trigger={
          <ButtonControl
            title={<div className='group-select__trigger-button'>{selectedGroup ? selectedGroup.title : 'Select a group'}<Icon icon='chevronDown' width={16} height={16} /></div>}
            newStyle
            size='medium'
            disabled={disabled}
          />
        }
        items={this.getDropdownItems()}
        disabled={disabled}
        newStyle
      />
    )
  }
}

export default GroupSelector
